import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  MenuItem,
  Select,
  TextareaAutosize,
  TextField
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { CancelRounded, SaveRounded } from "@material-ui/icons";
import { apiInspections } from "../../api/inspections";

export default function InspectionExtensionModal({ open, mode, inspection, onClose, onSave }) {
  const [date, setDate] = useState("");
  const [notes, setNotes] = useState("");
  const [templates, setTemplates] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");

  useEffect(() => {
    if (!open) {
      return;
    }
    setNotes("");
    setSubject("");
    setBody("");
    if (mode === "approve" && inspection?.ExtendedDeadline) {
      const d = new Date(inspection.ExtendedDeadline);
      setDate(d.toISOString().split("T")[0]);
    } else if (mode === "approve" && inspection?.ExtensionRequestedDate) {
      const d = new Date(inspection.ExtensionRequestedDate);
      setDate(d.toISOString().split("T")[0]);
    } else if (mode === "request") {
      setDate("");
    }

    if (mode === "request") {
      apiInspections.getExtensionTemplates()
        .then((res) => {
          const list = res.data && res.data.result || [];
          setTemplates(list);
          if (list.length > 0) {
            setTemplateName(list[0].name);
            setSubject(list[0].subject);
            setBody(list[0].body);
          }
        })
        .catch(() => {
          setTemplates([]);
          setTemplateName("");
        });
    }
  }, [open, mode, inspection]);

  const selectTemplate = (name) => {
    setTemplateName(name);
    const t = templates.find((x) => x.name === name);
    if (t) {
      setSubject(t.subject);
      setBody(t.body);
    }
  };

  const isRequest = mode === "request";
  const title = isRequest ? "Request Extension" : "Approve Extension";
  const description = isRequest
    ? "Enter the extension date you are requesting. Pick a template and tweak the subject/body for this send — the email goes to Orchid automatically."
    : "Adjust the approved deadline if needed, and paste in the response you received from Orchid. This records the approval on the inspection.";

  const handleSave = () => {
    if (date === "") {
      return;
    }
    onSave({ mode, date, notes, templateName, subject, body });
    onClose();
  };

  const canSave = isRequest
    ? date !== "" && subject.trim() !== "" && body.trim() !== ""
    : date !== "";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth={true}>
      <DialogContent>
        <DialogContentText className="tw-text-lg tw-font-bold tw-text-black">
          {title}
        </DialogContentText>
        <p className="tw-text-gray-700 tw-mb-4">{description}</p>

        {isRequest && templates.length > 0 && 
          <div className="tw-mb-4">
            <label className="tw-block tw-text-sm tw-text-gray-600 tw-mb-1">Email template</label>
            <Select
              fullWidth
              value={templateName}
              onChange={(e) => selectTemplate(e.target.value)}
              displayEmpty
            >
              {templates.map((t) => 
                <MenuItem key={t.name} value={t.name}>{t.name}</MenuItem>
              )}
            </Select>
          </div>
        }

        <TextField
          fullWidth
          label={isRequest ? "Extension date" : "Approved through"}
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min: new Date().toISOString().split("T")[0] }}
        />

        {isRequest && 
          <div className="tw-mt-4">
            <TextField
              fullWidth
              label="Subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <label className="tw-block tw-text-sm tw-text-gray-600 tw-mt-4 tw-mb-1">Body</label>
            <TextareaAutosize
              className="tw-w-full tw-border tw-border-gray-300 tw-rounded tw-p-2"
              rowsMin={10}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
          </div>
        }

        {!isRequest && 
          <TextareaAutosize
            autoFocus
            className="tw-w-full tw-border tw-border-gray-300 tw-rounded tw-p-2 tw-mt-4"
            rowsMin={6}
            placeholder="Notes / response received"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        }

        <DialogActions className="sm:tw-mt-4">
          <Button
            variant="contained"
            onClick={handleSave}
            color="primary"
            disabled={!canSave}
            startIcon={<SaveRounded/>}
          >
            {isRequest ? "Send Request" : "Save"}
          </Button>
          <Button
            variant="contained"
            onClick={onClose}
            color="secondary"
            startIcon={<CancelRounded/>}
          >
            Cancel
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}